import React from 'react';

/**
 * Full-width expansion bar at the bottom of the Filters card.
 * Rotating chevron + active count badge + preview of the advanced filters.
 */
const GPSAdvancedFiltersBar = ({ expanded, onToggle, activeCount = 0, preview = '' }) => (
  <div className="mt-2.5 border-t border-gray-200 dark:border-gray-900 pt-2.5">
    <button
      type="button"
      onClick={onToggle}
      className="flex items-center gap-3 w-full text-left outline-none"
    >
      <span className="inline-flex items-center justify-center w-6 h-6 rounded-lg bg-[#f3f1fe] dark:bg-[#2a2440] text-[#5b3df0] dark:text-[#a98ff5] transition-transform duration-200" style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </span>
      <span className="text-sm font-semibold text-gray-900 dark:text-white">Filtres avancés</span>
      {activeCount > 0 && (
        <span className="text-[11px] font-bold text-[#5b3df0] dark:text-[#a98ff5] bg-[#ece8fd] dark:bg-[#2a2440] rounded-full px-2 py-0.5">
          {activeCount}
        </span>
      )}
      <span className="ml-auto text-xs text-gray-400 dark:text-gray-500 font-medium truncate max-w-[55%]">
        {preview}
      </span>
    </button>
  </div>
);

export default GPSAdvancedFiltersBar;
